import { useThemedLogo } from "../../theme/useThemedLogo";
import { useRedmonkLogo } from "../../theme/useRedmonkLogo";
import { Typography, Row, Col, Layout, Space } from "antd";
import PublicHeader from "../../components/PublicHeader";
import MarketingFooter from "../../components/MarketingFooter";
import Seo from "../../components/Seo";
import EmbeddedLeadForm from "../../components/EmbeddedLeadForm";
import Reveal from "../../components/Reveal";

const { Title, Paragraph } = Typography;

const AboutUs = () => {
  const logo = useThemedLogo();
  const redmonklogo = useRedmonkLogo();
  const accessToken = localStorage.getItem("accessToken");
  const newsletterFormId = process.env.REACT_APP_MARKETING_NEWSLETTER_FORM_ID;

  return (
      <Layout className="marketing-page">
        <Seo
          title="About Mailinflow — Our Story"
          description="Mailinflow started as a simple idea and grew into a pocket-friendly email marketing tool built for startups. Learn about our mission."
          path="/about"
        />
        <div
          className="container"
          style={{ position: "fixed", left: 0, right: 0, zIndex: 999 }}
        >
          <PublicHeader logo={logo} accessToken={accessToken} />
        </div>

        <main>
          <div className="container">
            <section style={{ padding: "9rem 0 4rem", textAlign: "center" }}>
              <span className="mk-eyebrow">Our story</span>
              <Title
                style={{
                  fontSize: "clamp(28px, 4vw, 44px)",
                  lineHeight: 1.25,
                  margin: "1.5rem auto 0",
                  maxWidth: 620,
                }}
              >
                Mailinflow wasn't planned on a whiteboard.
              </Title>

              <div
                style={{
                  maxWidth: 640,
                  margin: "2.5rem auto 0",
                  textAlign: "left",
                }}
              >
                <Paragraph>
                  It started when a client came to us juggling a form embed,
                  a spreadsheet of leads, a spam problem, and a separate tool
                  for sending campaigns — none of it talking to each other.
                  We built the fix. Then the next client hit a different
                  wall, and we built that fix too.
                </Paragraph>
                <Paragraph>
                  A contact sitting in a database doesn't cost anything to
                  keep around — it's sending the email that costs money. So
                  why do so many platforms charge you just for having a
                  list? We didn't have a good answer either. Contact storage
                  on Mailinflow is free, always has been — you only pay for
                  what you actually send.
                </Paragraph>
                <Paragraph>
                  That's still how it works. We don't ship features because
                  they'd look good on a roadmap slide — we ship them because
                  a real customer ran into a real problem and needed a way
                  through it. If you're not stuck on something, we're
                  probably not building it yet.
                </Paragraph>
                <Paragraph style={{ marginBottom: 0 }}>
                  The same design discipline that goes into our client work
                  goes into every screen here too — user-friendly,
                  cost-effective tools that drive real productivity for
                  startups and small businesses.
                </Paragraph>
                <span
                  className="mk-mono"
                  style={{
                    display: "block",
                    marginTop: "1.5rem",
                    color: "var(--mk-ink-soft)",
                    fontSize: "13px",
                  }}
                >
                  built by Redmonk Studios
                </span>
              </div>
            </section>

            {newsletterFormId && (
              <Reveal as="section" style={{ padding: "0 0 4rem" }}>
                <Row justify="center">
                  <Col xs={24} sm={16} md={10}>
                    <Space
                      direction="vertical"
                      align="center"
                      style={{ width: "100%", textAlign: "center" }}
                    >
                      <Title level={3} style={{ marginBottom: "0.5rem" }}>
                        Get email marketing tips in your inbox
                      </Title>
                      <Paragraph type="secondary">
                        Occasional deliverability and lead-gen tips. No spam —
                        this form runs on our own anti-spam engine.
                      </Paragraph>
                    </Space>
                    <EmbeddedLeadForm
                      formId={newsletterFormId}
                      submitLabel="Subscribe"
                      successTitle="You're subscribed!"
                      successSubtitle="Watch your inbox for our next update."
                    />
                  </Col>
                </Row>
              </Reveal>
            )}
          </div>
        </main>

        <MarketingFooter logo={logo} redmonklogo={redmonklogo} />
      </Layout>
  );
};

export default AboutUs;
